import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["selectTag"]

  changeProfessional() {
    var getUrl = window.location;
    var baseUrl = getUrl .protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[0];

    document.location.href = baseUrl + `profile/working_hours/edit?professional_id=${this.selectTagTarget.value}`
  }
}